// tslint:disable:max-line-length

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule } from 'primeng/primeng';

import { Ng2BRPipesModule } from 'ng2-brpipes';

import { EmpregoNaPistaSharedModule } from '../shared/emprego-na-pista-shared.module';

import { ProvaPraticaRouting } from './prova-pratica.routing';

import { GerenciarProvaPraticaComponent } from './gerenciar-prova-pratica/gerenciar-prova-pratica.component';
import { CadastrarResultadoProvaPraticaComponent } from './cadastrar-resultado-prova-pratica/cadastrar-resultado-prova-pratica.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        ProvaPraticaRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule,

        Ng2BRPipesModule,

        EmpregoNaPistaSharedModule
    ],
    providers: [ ],
    declarations: [
        GerenciarProvaPraticaComponent,
        CadastrarResultadoProvaPraticaComponent,
    ],
})
export class ProvaPraticaModule { }



// WEBPACK FOOTER //
// ./src/app/components/provaPratica/prova-pratica.module.ts